/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';

import AlertsRow from './alerts-row';
import { bubbleStyle, headingStyle } from '../../../common';

import ErrorBoundary from '../../../../../components/ErrorBoundary';
import { Button } from '@components';

import {
	actionsCombiner,
	sidebarActions,
	userAlertActions,
} from '@utils/store/actions';

const DepositAlerts = ({
	depActions,
	depUSDTActions,
	__closeSideNotifs,
	innerRef,
	selectedCountry,
}) => {
	const [show, setShow] = useState(true);

	const totalDeposits = depActions.length + depUSDTActions.length;

	return (
		totalDeposits > 0 && (
			<React.Fragment>
				<div
					className="border-b border-gray-400 border-t border-separatorColor flex items-center justify-between p-4 cursor-pointer overflow-hidden"
					css={headingStyle}
					onClick={() => setShow(!show)}
				>
					<div className="font-bold text-primary uppercase">
						P2P Deposits:
						<div css={bubbleStyle}>{totalDeposits}</div>
					</div>

					<Button
						variant="minimal"
						className="p-2 text-base"
						size="tiny"
						css={css`
							margin: -6px 0;
							height: 24px;
							line-height: 0.8;
							width: 30px;
						`}
					>
						{show ? '—' : <span className="text-lg">+</span>}
					</Button>
				</div>
				{show && (
					<ul
						className="mt-0 p-0 bb-notifList"
						ref={innerRef}
						css={css`
							flex: 1;
						`}
					>
						{depActions.map(({ ref, ...notif }, index) => (
							<ErrorBoundary key={notif.ref_id}>
								<AlertsRow
									close={__closeSideNotifs}
									index={index}
									type="inr"
									country={selectedCountry}
									{...notif}
								/>
							</ErrorBoundary>
						))}
						{depUSDTActions.map(({ ref, ...notif }, index) => (
							<ErrorBoundary key={notif.ref_id}>
								<AlertsRow
									close={__closeSideNotifs}
									index={index}
									type="usdt"
									country={selectedCountry}
									{...notif}
								/>
							</ErrorBoundary>
						))}
					</ul>
				)}
			</React.Fragment>
		)
	);
};

export default connect(
	`depActions,
	depUSDTActions,
	selectedCountry,
	`,
	actionsCombiner(userAlertActions, sidebarActions)
)(DepositAlerts);
